<template>
  <div class="finance-overview">
    <!-- 数据总览 -->
    <el-card shadow="hover" class="overview-card">
      <div slot="header" class="card-header">
        <span>数据总览</span>
      </div>
      <el-descriptions :column="5" border size="small">
        <el-descriptions-item label="今日预充">{{ `¥${formatReading(totalDataObj.today_precharge)}` }}</el-descriptions-item>
        <el-descriptions-item label="已充电总金额">{{ `¥${formatReading(totalDataObj.all_charge_cost/10000)}` }}</el-descriptions-item>
         <el-descriptions-item label="总电费">{{ `¥${formatReading(totalDataObj.all_power_cost / 10000)}` }}</el-descriptions-item>
        <el-descriptions-item label="商户总数">{{ totalDataObj.merchant_num ? totalDataObj.merchant_num : '0' }}</el-descriptions-item>
        <el-descriptions-item label="开户总数">{{ totalDataObj.all_init_num ? totalDataObj.all_init_num : '0' }}</el-descriptions-item>

        
        <el-descriptions-item label="本月预充">{{ `¥${formatReading(totalDataObj.month_precharge)}` }}</el-descriptions-item>
        <el-descriptions-item label="已结算金额">{{ `¥${formatReading(totalDataObj.withdrawaled)}` }}</el-descriptions-item>
         <el-descriptions-item label="总服务费">{{ `¥${formatReading(totalDataObj.all_serv_cost / 10000)}` }}</el-descriptions-item>
        <el-descriptions-item label="商户站点数">{{ totalDataObj.merchant_site_num ? totalDataObj.merchant_site_num : '0' }}</el-descriptions-item>
        <el-descriptions-item label="本月开户数">{{ totalDataObj.month_init_num ? totalDataObj.month_init_num : '0' }}</el-descriptions-item>

        
        <el-descriptions-item label="预充总金额">{{ `¥${formatReading(totalDataObj.all_precharge)}` }}</el-descriptions-item>
        <el-descriptions-item label="待结算金额">{{ `¥${formatReading(totalDataObj.wait_withdrawal)}` }}</el-descriptions-item>
         <el-descriptions-item label="总初装费">{{ `¥${formatReading(totalDataObj.all_init_fee)}` }}</el-descriptions-item>
        <el-descriptions-item label="自营站点数">{{ totalDataObj.seft_site_num ? totalDataObj.seft_site_num : '0' }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 费用统计 -->
    <el-card shadow="hover" class="statistics-card">
      <div slot="header" class="card-header">
        <span>费用统计</span>
      </div>
      
      <!-- 筛选条件 -->
      <div class="filter-bar">
        <el-radio-group v-model="statsType" size="small" @change="handleStatsTypeChange">
          <el-radio-button label="day">按日统计</el-radio-button>
          <el-radio-button label="month">按月统计</el-radio-button>
        </el-radio-group>
        
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="margin-left: 16px; width: 280px;"
          @change="handleDateChange"
        >
        </el-date-picker>
        
        <el-button type="primary" size="small" style="margin-left: 16px;" @click="handleQuery">
          查询
        </el-button>
      </div>
      
      <!-- 图表容器 -->
      <div ref="chartContainer" class="chart-container"></div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {
  getHomeFinanceOverViewDataApi,
  getFinanceFeeStatisticDataApi
} from '@/api/data_statistic'

export default {
  name: 'FinanceOverview',
  data() {
    return {
      statsType: 'day', // day: 按日统计, month: 按月统计
      dateRange: [],
      chartInstance: null,
      chartData: {
        dates: [],
        electricityFee: [],
        serviceFee: []
      },
      totalDataObj: {},
    }
  },
  mounted() {
    this.initDefaultDateRange()
    this.$nextTick(() => {
      this.initChart()
      //this.fetchChartData()
      this.getPageData()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    formatReading(val) {
      if (val === null || val === undefined || val === '') return '0.00';
      return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getPageData(){
      this.getHomeFinanceOverViewData()
      this.getFinanceFeeStatisticData()
    },
    getHomeFinanceOverViewData(){
      getHomeFinanceOverViewDataApi().then((res) => {
        //console.log('财务概览数据获取',res)
        this.totalDataObj = res.data || {}
      }).catch((err) => {
        console.log('数据有误', JSON.stringify(err), err)
      }).finally(() => {

      })
    },
    getFinanceFeeStatisticData(){
      const startDate = new Date(this.dateRange[0])
      const endDate = new Date(this.dateRange[1])
      let requestData = {
        type: this.statsType == 'month' ? 2 : 1,
        start_time: this.statsType == 'month' ? this.formatMonthDate(startDate) : this.formatDayDate(startDate),
        end_time: this.statsType == 'month' ? this.formatMonthDate(endDate) : this.formatDayDate(endDate)
      }
      getFinanceFeeStatisticDataApi(requestData).then((res) => {
        console.log('财务费用统计数据获取',res)
        const responeData = res.data || [];
        const dates = []
        const electricityFee = []
        const serviceFee = []
        if(responeData && responeData.length > 0){
          responeData.forEach((item) => {
            dates.push(item.date_str)
            electricityFee.push(this.formatReading(item.elect_cost / 10000))
            serviceFee.push(this.formatReading(item.serv_cost / 10000))
          })
        }
        this.chartData = { dates, electricityFee, serviceFee }
        this.updateChart()
      }).catch((err) => {
        console.log('数据有误', JSON.stringify(err), err)
      }).finally(() => {

      })
    },
    formatDayDate(d){
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },
    formatMonthDate(m){
      return `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, '0')}`
    },
    // 初始化默认时间范围
    initDefaultDateRange() {
      const now = new Date()
      if (this.statsType === 'day') {
        // 按日统计：默认当日往前数15天
        const endDate = new Date(now)
        const startDate = new Date(now)
        startDate.setDate(startDate.getDate() - 14)
        this.dateRange = [startDate, endDate]
      } else {
        // 按月统计：默认当月往前数12个月
        const endDate = new Date(now.getFullYear(), now.getMonth(), 1)
        const startDate = new Date(now.getFullYear(), now.getMonth() - 11, 1)
        this.dateRange = [startDate, endDate]
      }
    },

    // 切换统计类型
    handleStatsTypeChange() {
      this.initDefaultDateRange()
      //this.fetchChartData()
      this.getPageData()
    },

    // 日期范围变化
    handleDateChange() {
      //this.fetchChartData()
      this.getPageData()
    },

    // 查询按钮
    handleQuery() {
      //this.fetchChartData()
      this.getPageData()
    },

    // 获取图表数据（模拟）
    fetchChartData() {
      // 这里应该调用后端接口获取真实数据
      // 目前使用模拟数据
      if (this.statsType === 'day') {
        this.generateDailyData()
      } else {
        this.generateMonthlyData()
      }
      this.updateChart()
    },

    // 生成按日统计数据（模拟）
    generateDailyData() {
      const dates = []
      const electricityFee = []
      const serviceFee = []
      
      const startDate = new Date(this.dateRange[0])
      const endDate = new Date(this.dateRange[1])
      
      for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
        const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        dates.push(dateStr)
        electricityFee.push(Math.floor(Math.random() * 200) + 50)
        serviceFee.push(Math.floor(Math.random() * 200) + 50)
      }
      
      this.chartData = { dates, electricityFee, serviceFee }
    },

    // 生成按月统计数据（模拟）
    generateMonthlyData() {
      const dates = []
      const electricityFee = []
      const serviceFee = []
      
      const startDate = new Date(this.dateRange[0])
      const endDate = new Date(this.dateRange[1])
      
      for (let m = new Date(startDate); m <= endDate; m.setMonth(m.getMonth() + 1)) {
        const dateStr = `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, '0')}`
        dates.push(dateStr)
        electricityFee.push(Math.floor(Math.random() * 5000) + 2000)
        serviceFee.push(Math.floor(Math.random() * 5000) + 2000)
      }
      
      this.chartData = { dates, electricityFee, serviceFee }
    },

    // 初始化图表
    initChart() {
      const chartDom = this.$refs.chartContainer
      if (!chartDom) return
      
      this.chartInstance = echarts.init(chartDom)
    },

    // 更新图表
    updateChart() {
      if (!this.chartInstance) return
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let result = params[0].name + '<br/>'
            params.forEach(param => {
              result += param.marker + param.seriesName + ': ¥' + param.value + '<br/>'
            })
            return result
          }
        },
        legend: {
          data: ['电费', '服务费'],
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.chartData.dates,
          axisLabel: {
            rotate: this.statsType === 'day' ? 0 : 45,
            fontSize: 11
          }
        },
        yAxis: {
          type: 'value',
          name: '金额(元)',
          nameTextStyle: {
            fontSize: 11
          },
          axisLabel: {
            fontSize: 11
          }
        },
        series: [
          {
            name: '电费',
            type: 'bar',
            stack: 'total',
            barWidth: '60%',
            itemStyle: {
              color: '#5470c6'
            },
            label: {
              show: true,
              position: 'inside',
              fontSize: 10,
              color: '#fff'
            },
            data: this.chartData.electricityFee
          },
          {
            name: '服务费',
            type: 'bar',
            stack: 'total',
            barWidth: '60%',
            itemStyle: {
              color: '#73c0de'
            },
            label: {
              show: true,
              position: 'inside',
              fontSize: 10,
              color: '#fff'
            },
            data: this.chartData.serviceFee
          }
        ]
      }
      
      this.chartInstance.setOption(option)
    },

    // 窗口大小变化时重新调整图表
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.finance-overview {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
}

.card-header {
  font-weight: bold;
  font-size: 14px;
}

.overview-card {
  flex-shrink: 0;
  
  ::v-deep .el-card__body {
    padding: 12px;
  }
  
  ::v-deep .el-descriptions {
    font-size: 12px;
  }
  
  ::v-deep .el-descriptions__label {
    background-color: #f5f7fa;
    font-weight: 500;
    padding: 8px 12px;
  }
  
  ::v-deep .el-descriptions__content {
    padding: 8px 12px;
  }
}

.statistics-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
    overflow: hidden;
  }
}

.filter-bar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.chart-container {
  flex: 1;
  min-height: 0;
  width: 100%;
}

// 响应式适配
@media (max-width: 1400px) {
  .overview-card ::v-deep .el-descriptions {
    font-size: 11px;
  }
  
  .overview-card ::v-deep .el-descriptions__label,
  .overview-card ::v-deep .el-descriptions__content {
    padding: 6px 8px;
  }
}

@media (max-width: 1200px) {
  .filter-bar {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .filter-bar .el-date-picker {
    margin-left: 0 !important;
    margin-top: 8px;
  }
  
  .filter-bar .el-button {
    margin-left: 0 !important;
    margin-top: 8px;
  }
}
</style>